import * as React from 'react';
import { CustomSubmitButton } from "soprasteria-ui-library";
import { ISaveReferral } from '../../../../models/IReferral';
import { useAuth } from '../../../../App';
import { ManageReferralApi } from "../../../../api/ManageReferralApi";
import { REFERRAL } from '../../../../utils/RouteConstants';
import { useHistory } from 'react-router-dom';

interface IReferralSendButton {
    isEditable: boolean;
    referralId?: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
}

export const ReferralSendButton: React.FunctionComponent<IReferralSendButton> = ({ isEditable, referralId, getReferral, changeErrorMessage, changeSuccessMessage }) => {

    const auth = useAuth();
    const manageReferralApi = new ManageReferralApi(auth);
    const [isReferralSending, setIsReferralSending] = React.useState<boolean>(false);
    const history = useHistory();

    const sendReferral = (data: ISaveReferral) => {
        setIsReferralSending(true);
        manageReferralApi.sendReferral(data, (newReferralId) => {
            if (referralId === undefined || referralId === 0) {
                history.replace(`${REFERRAL}/${newReferralId}`);
            }
            getReferral(newReferralId);
            changeSuccessMessage("Specialistremissen har skickats");
        }, (error) => {
            changeErrorMessage(error);
        }, () => {
            setIsReferralSending(false);
        });
    }

    return (
        <>
            {
                isEditable ?
                    <CustomSubmitButton isLoading={isReferralSending} onButtonSubmit={sendReferral}>Skicka specialistremiss</CustomSubmitButton>
                    : null
            }
        </>
    )
}